function scrollToTop() {
	window.scrollTo(0, 0)
}

$(function () {
	const lightbox = GLightbox()

	// Scroll to top
	$('#back-to-top').click(scrollToTop)

	// Preloader
	let preload_delay = 300
	$('.preloader').delay(preload_delay).fadeOut()

	// Stop these links from real navigation
	$(document).on('click', '.fake', null, function (e) {
		e.preventDefault()

		return false
	})

	// Add image sources
	const images_with_sources = $('img[data-source]')

	images_with_sources.each(function (idx, elem) {
		const image = $(elem)
		const source_text = image.data('source')

		if (source_text && images_with_sources.length > 0) {
			$('<p>').attr('class', 'source').html('<span class="icon fa-regular fa-image">&zwnj;</span> ' + source_text).insertAfter(image)
		}
	})
})
